import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDroplet } from "@fortawesome/free-solid-svg-icons";
import { faWind } from "@fortawesome/free-solid-svg-icons";

import "./WeatherInfo.css";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="card">
        <div className="card-body">
          <div className="location">
            {props.data.city}, {props.data.country}
            <FormattedDate date={props.data.date} />
          </div>
          <div className="row">
            <div className="weather-details">
              <ul>
                <li>
                  <WeatherIcon code={props.data.icon} color="white" />
                  {props.data.description}
                </li>
                <li>
                  <FontAwesomeIcon icon={faWind} className="icon list-icons" />
                  {props.data.wind}km/h
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faDroplet}
                    className="icon list-icons"
                  />
                  {props.data.humidity}%
                </li>
              </ul>
            </div>
            <div className="temperature-details">
              <WeatherTemperature
                mainTemp={props.data.temperature}
                highTemp={props.data.tempMax}
                lowTemp={props.data.tempMin}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
